<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="240"
      border
      :edit-rules="validRules"
    >
      <template v-slot:top>
        <div class="side-frame-success mt-3">
          <span
            class="side-frame-text"
            style="font-size: 15px;font-weight: 700"
          >
            {{ $l('form_label_store_contact') || '店铺联系人' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    orderExpenseCode: { type: String, default: '' },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      validRules: {
        contactName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        contactMobile: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
      },
    }
  },
  methods: {
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        { depCode: this.depCode, orgDepFullName: this.orgDepFullName },
        -1
      )
      await $itemTable.setActiveCell(newRow, 'currencyAmount')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}
</style>
